// extracted by mini-css-extract-plugin
export default {"contentCard":"TeamProfilContentCard_contentCard__VKZ85","contentPage":"TeamProfilContentCard_contentPage__QJHMA"};